import { useMemo } from 'react';
import { useGetBobcatTagsList } from '@/api/trafikportalen';

// Bobcat tags rarely change and are reused by every virtualized ticket row, so
// we keep them fresh for a while to avoid refetching while scrolling.
const TAGS_STALE_TIME = 1000 * 60 * 60; // 1 hour

// Maps Bobcat tag ids (e.g. `tc_a`, `pc_single`) to their human-readable titles
// (e.g. `Vuxen`, `Enkelbiljett`). The full tag list is used so tickets can be
// labelled even when the tag is not in the organization's allowed set.
export const useTagTitles = (): Record<string, string> => {
  const { data: tags } = useGetBobcatTagsList({
    query: { staleTime: TAGS_STALE_TIME },
  });

  return useMemo(() => {
    const titles: Record<string, string> = {};
    tags?.forEach((tag) => {
      titles[tag.tag_id] = tag.title;
    });
    return titles;
  }, [tags]);
};
